import * as React from 'react';

import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { useBookingDraftQuery } from '@/scopes/checkout/domain/hooks';
import { createCheckoutEvent } from '@/scopes/checkout/domain/analytics/index';
import type { CheckoutEventProps } from '@/scopes/checkout/domain/analytics/types';

export const useSendCheckoutEvent = () => {
  const { sendEvent } = useAnalytics();
  const { isLoading, data } = useBookingDraftQuery();

  const hasBeenSent = React.useRef(false);

  const sendCheckoutEvent = React.useCallback(() => {
    if (!data) return;
    sendEvent(
      createCheckoutEvent({
        userId: data?.draftId ?? '',
        ...data.analytics,
      } as CheckoutEventProps)
    );
  }, [sendEvent, data]);

  React.useEffect(() => {
    if (isLoading) return;
    if (hasBeenSent.current) return;
    sendCheckoutEvent();
    hasBeenSent.current = true;
  }, [isLoading, sendCheckoutEvent, hasBeenSent]);

  return {
    sendCheckoutEvent,
  };
};
